import { CSSObject } from '@chakra-ui/react';
import { rgba } from 'polished';

export const FlexWrapper = (theme: any): CSSObject => ({
  bg: rgba(theme.colors.epsilon[600] as string, 0.7),
});
